import React from 'react';
import { ColumnDef } from '@/components/ui/responsive-table';

// Hook para criar colunas facilmente
export function useTableColumns<T>(): {
  createColumn: (
    key: string,
    header: string,
    accessor: (item: T) => React.ReactNode,
    options?: Partial<ColumnDef<T>>
  ) => ColumnDef<T>;
} {
  const createColumn = (
    key: string,
    header: string,
    accessor: (item: T) => React.ReactNode,
    options: Partial<ColumnDef<T>> = {}
  ): ColumnDef<T> => ({
    key,
    header,
    accessor,
    ...options
  });

  return { createColumn };
}
